"use strict";

var _classCallCheck = require("/codebuild/output/src2429405957/src/github.com/wobicom/wobi-web-auto/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/codebuild/output/src2429405957/src/github.com/wobicom/wobi-web-auto/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _inherits = require("/codebuild/output/src2429405957/src/github.com/wobicom/wobi-web-auto/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _createSuper = require("/codebuild/output/src2429405957/src/github.com/wobicom/wobi-web-auto/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _he = _interopRequireDefault(require("date-fns/locale/he"));
var _format = _interopRequireDefault(require("date-fns/format"));
var _dateFns = _interopRequireDefault(require("@date-io/date-fns"));
var _pickers = require("@material-ui/pickers");
var _icons = require("../assets/js/icons");
var _DatepickerToolbar = _interopRequireDefault(require("./DatepickerToolbar"));
var _helpers = require("./utils/helpers");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var Left = (0, _helpers.getImageByAgent)('arrow-right.svg');
var Right = (0, _helpers.getImageByAgent)('arrow-left.svg');

// Original Datepicker documentation
// https://material-ui-pickers.dev/api/KeyboardDatePicker
var LocalizedUtils = /*#__PURE__*/function (_dateFns$default) {
  _inherits(LocalizedUtils, _dateFns$default);
  var _super = _createSuper(LocalizedUtils);
  function LocalizedUtils() {
    _classCallCheck(this, LocalizedUtils);
    return _super.apply(this, arguments);
  }
  _createClass(LocalizedUtils, [{
    key: "getDatePickerHeaderText",
    value: function getDatePickerHeaderText(date) {
      return (0, _format.default)(date, 'MMMM', {
        locale: this.locale
      });
    }
  }]);
  return LocalizedUtils;
}(_dateFns.default);
var DateTimePicker = function DateTimePicker(props) {
  var classes = useStyles();
  var _props$format = props.format,
    format = _props$format === void 0 ? 'dd/MM/yyyy HH:mm' : _props$format,
    _props$variant = props.variant,
    variant = _props$variant === void 0 ? 'inline' : _props$variant,
    _props$keyboardIcon = props.keyboardIcon,
    keyboardIcon = _props$keyboardIcon === void 0 ? /*#__PURE__*/_react.default.createElement(_icons.CalendarIcon, {
      label: "calendar"
    }) : _props$keyboardIcon,
    _props$label = props.label,
    label = _props$label === void 0 ? '' : _props$label,
    value = props.value,
    timezone = props.timezone;
  var datepickerComponent = /*#__PURE__*/_react.default.createElement(_pickers.MuiPickersUtilsProvider, {
    utils: LocalizedUtils,
    locale: _he.default
  }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, variant === 'static' ? /*#__PURE__*/_react.default.createElement(_pickers.DateTimePicker, {
    label: label,
    className: classes.input,
    locale: _he.default,
    keyboardIcon: keyboardIcon,
    margin: "normal",
    format: format,
    onChange: props.onChange,
    value: value,
    open: false,
    views: props.views ? props.views : ['year', 'month', 'date'],
    timezone: timezone || '	Asia/Jerusalem'
  }) : false, /*#__PURE__*/_react.default.createElement(_pickers.DateTimePicker, _extends({}, props, {
    value: props.value,
    className: "".concat(variant === 'static' ? 'open' : ''),
    locale: _he.default,
    format: format,
    keyboardIcon: keyboardIcon,
    rightArrowIcon: /*#__PURE__*/_react.default.createElement("img", {
      className: classes.arrow,
      alt: "\u05D7\u05D5\u05D3\u05E9 \u05E7\u05D5\u05D3\u05DD",
      src: Right
    }),
    leftArrowIcon: /*#__PURE__*/_react.default.createElement("img", {
      className: classes.arrow,
      alt: "\u05D7\u05D5\u05D3\u05E9 \u05D4\u05D1\u05D0",
      src: Left
    }),
    onChange: props.onChange,
    invalidDateMessage: props.invalidDateMessage || '',
    openTo: props.openTo ? props.openTo : 'date',
    views: props.views ? props.views : ['year', 'month', 'date', 'hours', 'minutes'],
    KeyboardButtonProps: {
      'aria-label': 'change date'
    },
    ToolbarComponent: _DatepickerToolbar.default,
    PopoverProps: {
      anchorOrigin: {
        horizontal: 'center',
        vertical: 'bottom'
      },
      PaperProps: {
        style: {
          marginTop: '6px'
        }
      },
      transformOrigin: {
        horizontal: 'center',
        vertical: 'top'
      }
    },
    timezone: timezone || '	Asia/Jerusalem'
  }))));
  if (variant === 'static') {
    return /*#__PURE__*/_react.default.createElement(_core.Paper, {
      className: "MuiPaper-elevation8"
    }, datepickerComponent);
  }
  return datepickerComponent;
};
var useStyles = (0, _core.makeStyles)({
  arrow: {
    width: '26px'
  },
  helper: {
    margin: 0
  },
  icon: {
    width: '23px'
  },
  input: {
    width: '100%'
  }
});
var _default = exports.default = DateTimePicker;